import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import './ScheduleModals.scss';

const CancelConfirmModal = ({ show, onHide, onConfirm, submitting }) => {
    return (
        <Modal show={show} onHide={onHide} centered size="sm" className="schedule-modal">
            <Modal.Header closeButton>
                <Modal.Title>Cancel Request</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to cancel this request? This action cannot be undone.</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={submitting} className="schedule-modal__btn">
                    No, Keep It
                </Button>
                <Button variant="danger" onClick={onConfirm} disabled={submitting} className="schedule-modal__btn">
                    {submitting ? 'Cancelling…' : 'Yes, Cancel Request'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CancelConfirmModal;
